import { DateRangeType } from "react-tailwindcss-datepicker";
import CustomDatePicker from "../awaitingInventory/CustomDatePicker";

interface DateRangeFilterOption {
  label: string;
  value: string;
}

interface DateRangeFilterProps {
  dates: DateRangeType;
  onDatesChange: (dates: DateRangeType) => void;
  dateFieldType: string;
  onDateFieldTypeChange: (type: string) => void;
  disabled?: boolean;
  className?: string;
  showLabels?: boolean;
  options?: DateRangeFilterOption[];
}

export default function DateRangeFilter({
  dates,
  onDatesChange,
  dateFieldType,
  onDateFieldTypeChange,
  disabled = false,
  className = "",
  showLabels = true,
  options = [
    { label: "Created", value: "Created" },
    { label: "Imaged On", value: "ImagedOn" },
    { label: "Listed On", value: "ListedDate" },
  ]
}: DateRangeFilterProps) {
  return (
    <div className={`flex flex-wrap gap-x-6 items-center ${className}`}>
      <div className="flex items-center gap-x-2">
        <div className="flex flex-col">
          {showLabels && <label className="text-sm font-medium text-gray-700 mb-1">Date Field</label>}
          <select
            value={dateFieldType}
            onChange={(e) => onDateFieldTypeChange(e.target.value)}
            className="border border-gray-300 rounded-md px-3 pr-8 py-2 text-sm"
            disabled={disabled}
          >
            {options.map((opt) => (
              <option key={opt.value} value={opt.value}>{opt.label}</option>
            ))}
          </select>
        </div>
        <div className="flex flex-col">
          {showLabels && <label className="text-sm font-medium text-gray-700 mb-1">Date Range</label>}
          <CustomDatePicker dates={dates} handleDatesChange={onDatesChange} />
        </div>
      </div>
    </div>
  );
}

